<template>
  <section>
    <h1 class="text-h3 mb-8">
      Date pickers
    </h1>
    <h2 class="text-h4 mb-4">
      Min date, allowed dates
    </h2>
    <v-sheet
      class="d-flex justify-center mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-date-picker
        v-model="date"
        :allowed-dates="allowedDates"
        :min="today"
      />
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Date range
    </h2>
    <v-sheet
      class="d-flex justify-center mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-row>
        <v-col
          cols="12"
          sm="5"
        >
          <v-date-picker
            v-model="dateRange"
            range
          />
        </v-col>
        <v-col
          cols="12"
          sm="7"
        >
          <v-text-field
            v-model="dateRangeText"
            label="Date range"
            readonly
          />
          <code>{{ dateRange }}</code>
        </v-col>
      </v-row>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Multiple dates
    </h2>
    <v-sheet
      class="d-flex justify-center mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-row>
        <v-col
          cols="12"
          sm="5"
        >
          <v-date-picker
            v-model="dateMultiple"
            multiple
          />
        </v-col>
        <v-col
          cols="12"
          sm="7"
        >
          <v-combobox
            v-model="dateMultiple"
            label="Multiple date picker"
            prepend-icon="fa-solid fa-calendar-days"
            multiple
            chips
            small-chips
            readonly
          />
          <code>{{ dateMultiple }}</code>
        </v-col>
      </v-row>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/date-pickers/">
      <strong>Date pickers</strong>
    </external-link>
  </section>
</template>

<script>
const today = new Date().toISOString().substr(0, 10)

export default {
  name: 'FormDatePickers',
  data: () => ({
    today,
    date: today,
    dateRange: [today, today],
    dateMultiple: []
  }),
  computed: {
    dateRangeText () {
      return this.dateRange.join(' ~ ')
    }
  },
  methods: {
    allowedDates (val) {
      return parseInt(val.split('-')[2], 10) % 2 === 0
    }
  }
}
</script>
